import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Business Description Step Component
 *
 * Step 1 of the Brand Profile Wizard.
 * Collects: Business description - a detailed text about what the business does
 */
export default function BusinessDescriptionStep({ data, onChange }) {
  const { t } = useTranslation('brandProfile')

  // Handle business description change
  const handleDescriptionChange = useCallback(
    (e) => {
      onChange({ business_description: e.target.value.slice(0, 1000) })
    },
    [onChange]
  )

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900">
          {t('wizard.steps.business_description.title')}
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          {t('wizard.steps.business_description.subtitle')}
        </p>
      </div>

      {/* Business Description Textarea */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t('wizard.steps.business_description.label')}
        </label>
        <textarea
          value={data.business_description || ''}
          onChange={handleDescriptionChange}
          placeholder={t('wizard.steps.business_description.placeholder')}
          rows={8}
          className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
        />
        <div className="mt-1 flex justify-between text-xs text-gray-400">
          <span>{t('wizard.steps.business_description.hint')}</span>
          <span>{(data.business_description || '').length}/1000</span>
        </div>
      </div>

      {/* Examples */}
      <div className="bg-blue-50 rounded-lg p-4">
        <h4 className="text-sm font-medium text-blue-800 mb-2">
          {t('wizard.steps.business_description.examplesTitle')}
        </h4>
        <ul className="text-xs text-blue-700 space-y-2">
          <li>&bull; {t('wizard.steps.business_description.example1')}</li>
          <li>&bull; {t('wizard.steps.business_description.example2')}</li>
          <li>&bull; {t('wizard.steps.business_description.example3')}</li>
        </ul>
      </div>
    </div>
  )
}
